export const CHECKOUT_URL = 'https://fire-service-instructor-atlas.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/dws16B5FVFprsTAUrCW4tU/Diseno_sin_titulo_(73).png'

export const HERO_IMAGE_ALT =
  'Fire Service Instructor Atlas 6-in-1 box set: 6 professional visual training volumes for firefighter instructors'

export const PRIMARY_CTA = 'GET FIRE SERVICE INSTRUCTOR ATLAS NOW'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 01 — Firefighter Foundations, PPE & Equipment Atlas' },
  { kind: 'included', label: 'Volume 02 — Hose, Water Supply & Fireground Operations' },
  { kind: 'included', label: 'Volume 03 — Ladders, Forcible Entry, Ventilation & Building Access' },
  { kind: 'included', label: 'Volume 04 — Search, Rescue & Structural Fire Operations' },
  { kind: 'included', label: 'Volume 05 — Vehicle Rescue & Technical Incident Atlas' },
  { kind: 'included', label: 'Volume 06 — Instructor Drills, Scenarios, Assessments & Decision Tools' },
  { kind: 'bonus', label: 'Fire Service Instructor Lesson Planning System' },
  { kind: 'bonus', label: 'Firefighter Scenario & Decision-Making Library' },
  { kind: 'bonus', label: 'Firefighter Assessment & Progress Tracking Handbook' },
  { kind: 'bonus', label: 'Fire Service Instructor Question Bank' },
  { kind: 'bonus', label: 'Fire Service Debriefing & After-Action Review Manual' },
  { kind: 'included', label: '100% Visual Main Training System' },
  { kind: 'included', label: 'Immediate Digital Access' },
]
